module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/95287153dfcad0aadb5489385bd1e211.png";